import React, { useEffect, useMemo, useState } from 'react'
import { Form, Skeleton } from 'antd'
import { filter, find, get, isArray, some } from 'lodash'
import styled from 'styled-components'

import { getMenuById, getQuestionsByMenuId } from 'src/useCase/question'
import { HeaderStyle } from 'src/components/layout/Header/HeaderStyle'
import StepsHeader from 'src/components/layout/Header/StepHeader'
import { Wrapper } from 'src/components/layout/Wrapper'
import ButtonCustom from 'src/components/form/Button'
import LPHeader from 'src/components/layout/Header/LPHeader'
import { useAppDispatch, useAppSelector } from 'src/store'
import { QuestionItem } from './styled'
import { useQuestionForm } from './QuestionForm'
import { getInfo } from 'src/useCase/user'
import { useParams, useSearchParams } from 'react-router-dom'
import LocalStorage from 'src/utils/LocalStorage'
import MenuNameComponent from 'src/components/common/MenuNameComponent'
import UserInfoForm from 'src/containers/Auth/Register/components/UserInfoForm'
import { useRegister } from 'src/containers/Auth/Register/components/useRegisterForm'
import { createUserTreatment } from 'src/useCase/userTreatment'
import { useForm, UseFormReturn } from 'react-hook-form'
import addressRequest from 'src/api/requests/address'
import PrecautionDocument from '../components/Precaution/Document'
import { USER_TREATMENT_STATE } from 'src/enum/userTreatmentState'
import appActions from 'src/store/ui/app'
import moment from 'moment'

type UserTreatmentFormValues = {
  menu_id: string | number | null
  plan_id?: string | number | null
}
const QuestionContainer = (props: any) => {
  const dispatch = useAppDispatch()
  const paramsUrl = useParams()
  const [searchParams] = useSearchParams()
  const menuId = searchParams.get('menuId') || paramsUrl?.id
  const from = searchParams.get('from')
  const planIdParam = searchParams.get('planId')
  const [isChecked, setIsChecked] = useState(false)
  const [hasReadPrecaution, setHasReadPrecaution] = useState(false)
  const clinicId = searchParams.get('clinicId')
  const [menuName, setMenuName] = useState('')
  const [menuData, setMenuData] = useState<any>(null)

  const { form, onSubmit: submitQuestion, onValidateForm } = useQuestionForm()
  const { setValue, formState: qFormState, setError } = form

  const { form: userForm, onSubmit: submitUserInfo } = useRegister()

  const [submitData, setSubmitData] = useState({
    answers: [],
    reservation_id: '',
    menu_id: 0,
  })

  const questionList = useAppSelector(
    (state) => state.domain.automaticPlan.questions.entity,
  )
  const isLoadingQuestionList =
    useAppSelector((state) => state.domain.automaticPlan.questions.loading) ||
    false
  const questionObject =
    questionList &&
    questionList.length > 0 &&
    questionList.reduce((a, v, key) => ({ ...a, [`${key + 1}`]: v }), {})

  const userInfo = useAppSelector((state) => state.ui.app.authInfo)
  const userTreatment = useMemo(() => {
    return find(
      userInfo?.user_treatments,
      (userTreatment) => userTreatment.menu_id == paramsUrl?.id,
    )
  }, [userInfo])
  const [isSubmittingAll, setIsSubmittingAll] = useState(false)

  let reservation = userTreatment?.reservation

  if (!reservation && userTreatment?.reservations) {
    reservation =
      find(
        userTreatment?.reservations,
        (reservation) => reservation?.answers?.length === 0,
      ) || userTreatment?.reservations[userTreatment?.reservations?.length - 1]
  }

  const userTreatmentForm: UseFormReturn<UserTreatmentFormValues, any> =
    useForm<UserTreatmentFormValues>({
      defaultValues: {
        menu_id: null,
        plan_id: null,
      },
    })

  const questionRefs = useMemo(
    () => ({} as Record<string, HTMLDivElement | null>),
    [],
  )

  const isSubmitDisabled = !(isChecked && hasReadPrecaution)

  useEffect(() => {
    if (!menuName && menuId && clinicId) {
      dispatch(
        getMenuById({
          menuId,
          params: {
            clinic_id: clinicId,
            select_field:
              'id,name,status,created_at,updated_at,is_default,image_url,target_gender',
          },
        }),
      )
        .then((res: any) => {
          const menu = res.payload
          setMenuData(menu)
          setMenuName(menu?.name || '')
        })
        .catch(() => setMenuName(''))
    }
  }, [menuId, clinicId, dispatch, menuName])

  useEffect(() => {
    if (menuId) {
      dispatch(getQuestionsByMenuId({ menu_id: menuId }))
    }
  }, [menuId, dispatch])

  useEffect(() => {
    if (from === 'LP') {
      return
    }
    LocalStorage.removePrecaution()
    dispatch(
      getInfo({
        with: 'userTreatments,userTreatments.reservations,userTreatments.reservations.answers,userTreatments.userTreatmentTransitions',
      }),
    )
  }, [dispatch, from])

  const handleChange = (name: any, type: string, questionAnswer: any) => {
    if (type === 'checkbox') {
      if (
        questionAnswer &&
        !some(
          form.watch(name),
          (checkboxValue) => checkboxValue.value === questionAnswer.value,
        )
      ) {
        const formValue = form.watch(name)
        if (formValue) {
          setValue(name, [...formValue, questionAnswer])
          setError(name, {})
        } else {
          setValue(name, [questionAnswer])
          setError(name, {})
        }
      } else {
        setValue(name, [
          ...filter(
            form.watch(name),
            (data) => data.value !== questionAnswer.value,
          ),
        ])
        setError(name, {})
      }
    } else {
      setValue(name, questionAnswer)
      setError(name, {})
    }
    const data = form.getValues()

    let answerData: any = []

    data &&
      Object.entries(data).map((formValue) => {
        const data =
          questionObject &&
          find(
            questionObject,
            (data) => get(data, 'id') === Number(formValue[0]),
          )
        const questionData = questionObject ? data : { type: '', id: '' }
        const value = get(formValue, '1', null)

        if (questionData) {
          const questionType = questionData.type

          let valueInput = {
            is_call_video: false,
            value: value,
            count_number: get(questionData, 'options.count_number', 0),
          }
          let nextAnswer: any = {
            answer:
              questionType === 'radio'
                ? [value]
                : questionType == 'checkbox'
                ? value
                : [valueInput],
            question_id: questionData.id,
            question_type: questionData.type,
          }

          answerData = [...answerData, nextAnswer]
        }
      })

    setSubmitData((prev) => {
      const reservationId = reservation?.id ?? null
      return {
        ...prev,
        answers: answerData,
        reservation_id: reservationId,
        menu_id: Number(menuId) || 0,
      }
    })

    return
  }

  const handleClick = () => setIsChecked((prev) => !prev)

  const handleSubmitAll = async () => {
    if (isSubmittingAll) return
    setIsSubmittingAll(true)

    try {
      if (!userInfo) {
        const userValid = await userForm.trigger()
        if (!userValid) {
          const err = userForm.formState.errors
          const firstErrName = Object.keys(err)[0] as any
          if (firstErrName) userForm.setFocus(firstErrName)
          return
        }
      }

      const { valid: questionValid, firstErrorId } = await onValidateForm(
        submitData,
      )
      if (!questionValid) {
        const firstErrName = firstErrorId as any
        if (firstErrName) {
          form.setFocus(firstErrName)

          const target = questionRefs[firstErrName]
          if (target) {
            target.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
            })
          }
        }
        return
      }

      const userData = userForm.getValues()

      if (!userInfo) {
        const targetGender = menuData?.target_gender
        const userGender = userData.gender_id

        const invalidGender = Boolean(
          Number(targetGender) &&
            Number(targetGender) !== 2 &&
            Number(targetGender) !== Number(userGender),
        )

        userForm.clearErrors('gender_id')

        if (invalidGender) {
          userForm.setError('gender_id', {
            type: 'manual',
            message: 'このメニューは選択した性別ではご利用できません。',
          })
          return
        }

        const ok = await submitUserInfo(userData, '', null)
        if (!ok) return
      }

      const planId = planIdParam ? Number(planIdParam) : ''

      let reservationId = reservation?.id
      if (
        !reservationId ||
        userTreatment?.state === USER_TREATMENT_STATE.CANCELED
      ) {
        try {
          const newUserTreatment = await dispatch(
            createUserTreatment({
              data: { menu_id: Number(menuId), plan_id: planId },
              form: userTreatmentForm,
            }),
          ).unwrap()

          if (userInfo) {
            const userTreatments = [...(userInfo?.user_treatments || [])]
            const newTreatmentInx = userTreatments.findIndex(
              (ut) => ut.id === newUserTreatment.id,
            )

            if (newTreatmentInx !== -1) {
              userTreatments.splice(newTreatmentInx, 1, newUserTreatment)
            } else {
              userTreatments.push(newUserTreatment)
            }

            const newUser = {
              ...userInfo,
              user_treatments: [...userTreatments],
            }

            dispatch(appActions.updateAuthInfo(newUser))
          }

          reservationId = newUserTreatment?.reservation?.id || null
        } catch (e) {
          return
        }
      }

      const finalSubmitData = {
        ...submitData,
        reservation_id: reservationId,
        menu_id: Number(menuId) || 0,
      }
      if (!(await submitQuestion(finalSubmitData))) return

      if (!userInfo?.phone && userData.phone) {
        await addressRequest.updatePhone({ phone: userData.phone })
      }

      const isOtpExpired =
        !userInfo?.otp_expire_at ||
        moment().isSameOrAfter(moment(userInfo.otp_expire_at))

      if (userInfo?.phone && !userInfo?.otp_verified_at && isOtpExpired) {
        await addressRequest.resendOTP()
      }

      LocalStorage.removeLocalStorage('selected_gender')
    } finally {
      setIsSubmittingAll(false)
    }
  }

  if (isLoadingQuestionList) {
    return <Skeleton />
  }

  return (
    <>
      <LPHeader />
      <Wrapper className="w-full justify-center mx-auto">
        <StepsHeader
          step={10}
          // stepActive={2}
          stepActiveName={'問診・注意事項確認'}
          className="top-70"
        />
        <div>
          {!userInfo ? (
            <HeaderStyle>ご利用者情報入力</HeaderStyle>
          ) : (
            <>
              <HeaderStyle>問診票</HeaderStyle>
              <MenuNameComponent className="mb-25" menuNameProp={menuName} />
            </>
          )}
        </div>

        {isLoadingQuestionList ? (
          <div className="mx--20">
            <Skeleton />
          </div>
        ) : (
          <Form className="pb-20">
            {!userInfo && (
              <>
                <UserInfoForm form={userForm} asForm={false} />
                <HeaderStyle>問診票</HeaderStyle>
                <MenuNameComponent className="mb-25" menuNameProp={menuName} />
              </>
            )}
            {questionList &&
              questionList.length > 0 &&
              questionList.map((question, index) => {
                const qName: any = `${question.id}`
                const questionName =
                  question.question && question.question.split('\\n')
                let maxLengthOption = 0
                question.options &&
                  isArray(question.options) &&
                  question.options.map((option) => {
                    if (option.value.length > Number(maxLengthOption)) {
                      maxLengthOption = option.value.length
                    }
                    return option
                  })

                if (maxLengthOption < 30) {
                  maxLengthOption = 30
                }

                return (
                  <QuestionItem
                    key={question.id}
                    ref={(el) => {
                      questionRefs[question.id] = el
                    }}
                    className={
                      form.getFieldState(qName)?.error &&
                      Object.keys(
                        form.getFieldState(qName)?.error || {},
                      ).filter((key) => key !== 'ref').length > 0
                        ? 'has-error'
                        : ''
                    }
                  >
                    <div className="q-title">
                      <div className="q-left">
                        Q{index + 1}{' '}
                        <span className="pre-wrap">
                          {questionName &&
                            questionName.map(function (item, idx) {
                              return (
                                <span key={idx}>
                                  {item}
                                  <br />
                                </span>
                              )
                            })}
                        </span>
                      </div>
                      {question.required && (
                        <span className="required">必須</span>
                      )}
                    </div>
                    {question.type === 'checkbox' && (
                      <>
                        <div className="q-wrap">
                          {question.options.length > 0 &&
                            question.options.map((item, index) => {
                              const isChecked =
                                form.watch(qName) &&
                                some(
                                  form.watch(qName),
                                  (checkboxValue) =>
                                    checkboxValue.value === item.value,
                                )

                              return (
                                <label
                                  className="label-q c-pointer"
                                  key={index}
                                >
                                  <input
                                    type="checkbox"
                                    placeholder="January"
                                    name={qName}
                                    className="btn-q mx-3"
                                    onChange={(event) =>
                                      handleChange(
                                        event.target.name,
                                        'checkbox',
                                        item,
                                      )
                                    }
                                    checked={isChecked}
                                    value={item.value}
                                    id={`${qName}-${item.value}-${index}`}
                                  />
                                  <span
                                    style={{
                                      padding: `${
                                        maxLengthOption / 2.4 + 10
                                      }px 0`,
                                    }}
                                  >
                                    {item.value}
                                  </span>
                                </label>
                              )
                            })}
                        </div>
                        {form.getFieldState(qName) &&
                          form.getFieldState(qName).error?.message && (
                            <div className="error-text">選択してください。</div>
                          )}
                      </>
                    )}
                    {question.type === 'radio' && (
                      <>
                        <div className="q-wrap">
                          {question.options.length > 0 &&
                            question.options.map((item, index) => {
                              return (
                                <label
                                  className="label-q c-pointer"
                                  key={index}
                                >
                                  <input
                                    type="radio"
                                    placeholder="January"
                                    name={qName}
                                    className="btn-q mx-3"
                                    checked={
                                      form.watch(qName) &&
                                      form.watch(qName).value === item.value
                                    }
                                    onChange={(event) =>
                                      handleChange(
                                        event.target.name,
                                        'radio',
                                        item,
                                      )
                                    }
                                    value={item.value}
                                    id={`${qName}-${item.value}`}
                                  />
                                  <span
                                    style={{
                                      padding: `${
                                        maxLengthOption / 2.4 + 10
                                      }px 0`,
                                    }}
                                  >
                                    {item.value}
                                  </span>
                                </label>
                              )
                            })}
                        </div>
                        {form.getFieldState(qName) &&
                          form.getFieldState(qName).error?.message && (
                            <div className="error-text">選択してください。</div>
                          )}
                      </>
                    )}
                    <div className="px--20 mb-20">
                      {question.type === 'textarea' && (
                        <>
                          <textarea
                            name={qName}
                            className="aga-input question-input mb-10 px-10 aga-input-area"
                            placeholder={
                              question.placeholder || '入力してください'
                            }
                            onChange={(event) =>
                              handleChange(
                                event.target.name,
                                'textarea',
                                event.target.value,
                              )
                            }
                          />
                          {form.getFieldState(qName) &&
                            form.getFieldState(qName).error?.message && (
                              <div className="error-text mt-e-20 px--0">
                                入力してください。
                              </div>
                            )}
                        </>
                      )}
                    </div>
                    <div className="px--20 mb-20">
                      {question.type === 'input' && (
                        <>
                          <input
                            name={qName}
                            className="aga-input question-input mb-10 px-10"
                            placeholder={
                              question.placeholder || '入力してください'
                            }
                            onChange={(event) =>
                              handleChange(
                                event.target.name,
                                'input',
                                event.target.value,
                              )
                            }
                          />
                          {form.getFieldState(qName) &&
                            form.getFieldState(qName).error?.message && (
                              <div className="error-text mt-e-20 px--0">
                                入力してください。
                              </div>
                            )}
                        </>
                      )}
                    </div>
                  </QuestionItem>
                )
              })}
            <HeaderStyle>注意事項の確認</HeaderStyle>
            <PrecautionDocument setHasReadPrecaution={setHasReadPrecaution} />
            <div className="mt-3">
              <b>
                利用規約を最後までスクロールすると、以下利用規約への同意にチェックができます。
              </b>
            </div>
            <CustomCheckbox>
              <label className="checkbox-label checkbox-all mt-3">
                <div>
                  <input
                    type="checkbox"
                    onClick={() => handleClick()}
                    className={`
                  checkbox-checkmark ${isChecked ? 'checked' : ''} ${
                      !hasReadPrecaution ? 'disabled' : ''
                    }`}
                    disabled={!hasReadPrecaution}
                  />
                  <span
                    className={`
                    checkbox-checkmark ${isChecked ? 'checked' : ''} ${
                      !hasReadPrecaution ? 'disabled' : ''
                    }
                  `}
                  ></span>
                  <span>
                    上記の全ての利用規約（はじめにご確認いただく事項ならびに、利用規約第3条に記載のリンク先「医薬品リスト」も確認し、内容についても理解しています）に同意します。
                  </span>
                </div>
              </label>
            </CustomCheckbox>
            <div className="p-20">
              <ButtonCustom
                className="btn-default btn-chestnut-rose"
                loading={
                  isSubmittingAll ||
                  userForm.formState.isSubmitting ||
                  qFormState.isSubmitting
                }
                disabled={isSubmitDisabled}
                onClick={handleSubmitAll}
                name="次へ進む"
                showIconRight
              />
            </div>
          </Form>
        )}
      </Wrapper>
    </>
  )
}

const CustomCheckbox = styled.div`
  .checkbox-label {
    display: block;
    position: relative;
    padding-left: 15px;
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 20px;
    color: #000000;
    user-select: none;
    border-bottom: 1px solid #f1efe7;
    padding-bottom: 15px;
    margin-top: 15px;
    cursor: pointer;

    &.checkbox-all {
      padding-left: 40px;
      border-bottom: none;
      display: inline-flex;
      align-items: center;

      span {
        line-height: 32px;
      }
    }

    .checkbox-title {
      a {
        color: hsl(209, 100%, 37.5%);
      }
    }
    .checkbox-checkmark:after {
      left: 8px;
      top: 3px;
      width: 10px;
      height: 18px;
      border: solid white;
      border-width: 0 3px 3px 0;
      transform: rotate(45deg);
    }
    input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
      height: 0;
      width: 0;
    }
    .checkbox-checkmark {
      position: absolute;
      top: 0;
      left: 0;
      height: 28px;
      width: 28px;
      background-color: var(--color-spring-wood);
      border-radius: 5px;
    }
    .checkbox-checkmark:after {
      content: '';
      position: absolute;
      display: none;
    }

    .disabled {
      cursor: not-allowed;
    }
  }
  .checked {
    background-color: var(--color-yuma) !important;
    border: 1px solid var(--color-yuma) !important;
  }
  .checkbox-checkmark {
    &.checked:after {
      display: block;
    }
  }
`

export default QuestionContainer
